import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";
export default function ComparePlayersShootingDrills(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
  }));
  const classes = useStyles();
  const {
    favPlayersShootingDrillData,
    playerShootingDrillsColumns,
    favPlayersShootingDrillDataselected,
    Showval,
    notes,
    loading,
    spotUp,
    sideMidSide,
    midSideMid,
    offTheDribble,
    freeThrows,
    point3Star,
    midRangeStar,
    eventId,
  } = props;

  const [shootingDrillsOrder, setShootingDrillsOrder] = React.useState("asc");

  const [shootingDrillsOrderBy, setShootingDrillsOrderBy] =
    React.useState("playerName");

  const handleShootingDrillsSortRequest = (e, property) => {
    const isAsc =
      shootingDrillsOrderBy === property && shootingDrillsOrder === "asc";
    setShootingDrillsOrder(isAsc ? "desc" : "asc");
    setShootingDrillsOrderBy(property);
  };
  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => descendingComparator(a, b, sortOrder, sortOrderBy);
  }
  function descendingComparator(a, b, sortOrder, sortOrderBy) {
    if (a[sortOrderBy] === b[sortOrderBy]) {
      return 0;
    } else if (sortOrder === "asc") {
      return a[sortOrderBy] < b[sortOrderBy] ? -1 : 1;
    } else {
      return a[sortOrderBy] < b[sortOrderBy] ? 1 : -1;
    }
  }
  const viewPlayerProfile = (playerId) => {
    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 2 },
    });
  };
  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Shooting Drills
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {favPlayersShootingDrillData &&
                favPlayersShootingDrillData.length > 0 && (
                  <Table>
                    <TableHead>
                      {playerShootingDrillsColumns.map((elem, i) => {
                        return (
                          <TableCell
                            className={
                              elem.id === "playerName"
                                ? classes.stickyColumn
                                : classes.na
                            }
                            sx={{
                              padding: "4px",
                              paddingLeft:
                                elem.id === "playerName" ? "25px" : "0px",
                            }}
                          >
                            <TableSortLabel
                              active={shootingDrillsOrderBy === elem.id}
                              direction={
                                shootingDrillsOrderBy === elem.id
                                  ? shootingDrillsOrder
                                  : "asc"
                              }
                              onClick={(e) =>
                                handleShootingDrillsSortRequest(e, elem.id)
                              }
                            >
                              {elem.headerName}
                              {shootingDrillsOrderBy === elem.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                  {shootingDrillsOrder === "desc"
                                    ? "sorted descending"
                                    : "sorted ascending"}
                                </Box>
                              ) : null}
                            </TableSortLabel>
                          </TableCell>
                        );
                      })}
                    </TableHead>
                    <TableBody>
                      {Showval
                        ? favPlayersShootingDrillDataselected
                            .slice()
                            .sort(
                              getComparator(
                                shootingDrillsOrder,
                                shootingDrillsOrderBy
                              )
                            )
                            .map((val, index) => {
                              return (
                                <TableRow>
                                  <TableCell
                                    className={classes.stickyColumn}
                                    sx={{ padding: "5px" }}
                                  >
                                    <Box display="flex">
                                      {val.headshotURL &&
                                      val.headshotURL !== "" ? (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          src={
                                            val.headshotURL
                                              ? baseUrl(val.headshotURL)
                                              : ""
                                          }
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(val.playerID)
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      ) : (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(val.playerID)
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      )}
                                      &nbsp;&nbsp;
                                      <Typography
                                        variant="body2"
                                        className={classes.playerNameStyle}
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        {val.playerName}
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.position ? val.position : "-"}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeSpotup}/{val.maxCountSoptUp}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeSideMidSide}/
                                    {val.maxCountSideMidSide}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeMidSideMid}/
                                    {val.maxCountMidSideMid}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeOffTheDribble}/
                                    {val.maxCountOffTheDribble}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeFreeThrows}/
                                    {val.maxCountFreeThrows}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMade3PointStar}/
                                    {val.maxCount3PointStar}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeMidRangeStar}/
                                    {val.maxCountMidRangeStar}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        : favPlayersShootingDrillData
                            .slice()
                            .sort(
                              getComparator(
                                shootingDrillsOrder,
                                shootingDrillsOrderBy
                              )
                            )
                            .map((val, index) => {
                              return (
                                <TableRow>
                                  <TableCell
                                    className={classes.stickyColumn}
                                    sx={{ padding: "4px" }}
                                  >
                                    <Box display="flex">
                                      {val.headshotURL &&
                                      val.headshotURL !== "" ? (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          src={
                                            val.headshotURL
                                              ? baseUrl(val.headshotURL)
                                              : ""
                                          }
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(val.playerID)
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      ) : (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(val.playerID)
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      )}
                                      &nbsp;&nbsp;
                                      <Typography
                                        variant="body2"
                                        className={classes.playerNameStyle}
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        {val.playerName}
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.position ? val.position : "-"}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeSpotup}/{val.maxCountSoptUp}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeSideMidSide}/
                                    {val.maxCountSideMidSide}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeMidSideMid}/
                                    {val.maxCountMidSideMid}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeOffTheDribble}/
                                    {val.maxCountOffTheDribble}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeFreeThrows}/
                                    {val.maxCountFreeThrows}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMade3PointStar}/
                                    {val.maxCount3PointStar}
                                  </TableCell>
                                  <TableCell style={{ padding: "4px" }}>
                                    {val.noOfMadeMidRangeStar}/
                                    {val.maxCountMidRangeStar}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                    </TableBody>
                  </Table>
                )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>

      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Shooting Drills
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "Shooting".toLowerCase()
                ).isActive && (
                  <>
                    {/* <InfoOutlinedIcon style={{ color: "#fff" }} /> */}
                    <Typography
                      // className="subtitle2"
                      className={classes.headerTextInfo}
                    >
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "Shooting".toLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>
          {loading && (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          )}
          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Spot Up"
              data={spotUp}
              value="301"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="Side Mid Side"
              data={sideMidSide}
              value="302"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="Mid Side Mid"
              data={midSideMid}
              value="307"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="Off The Dribble"
              data={offTheDribble}
              value="303"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="Free Throws"
              data={freeThrows}
              value="304"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="3-Point Star"
              data={point3Star}
              value="305"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />

            <DashboardCard
              title="Mid Range Star"
              data={midRangeStar}
              value="306"
              from="CombineResults"
              tab={2}
              eventId={eventId}
            />
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
